// extracted by mini-css-extract-plugin
module.exports = {"checkboxEstrangeiro":"CadastroClienteSeguroAventuraPropriedadeDiarias_checkboxEstrangeiro__1XeyJ"};